import { call, put, takeLatest, select } from "redux-saga/effects";
import { authenticatedCall } from "shared/helpers/sagas";
import * as types from "store/editSession/editSessionTypes";
import * as interviewTypes from "store/interviewsList/interviewsListTypes";
import API from "store/editSession/editSessionApis";
import InterviewsAPI from "store/interviewsList/interviewsListApis";
import { isPMOrAdmin } from "shared/helpers/user";
import React from "react";

function* getInvalidateInterviewEmailTemplateRequested(payload) {
  try {
    const response = yield call(
      API.getInvalidateInterviewEmailTemplate,
      payload.payload,
    );
    if (response.status === 200) {
      console.log("[DEBUG] API body_content:", response.data.body_content);
      const htmlDoc = new DOMParser().parseFromString(
        response.data.body_content,
        "text/html",
      );
      const ionqyElem = htmlDoc.getElementById("ionqy");
      console.log("[DEBUG] ionqy element:", ionqyElem);
      const template = {
        __html: ionqyElem
          ? `<table style="background: #e4e4e4">${ionqyElem.outerHTML}</table>`
          : "",
      };
      console.log(
        "[DEBUG] GET_INVALIDATE template length:",
        (template.__html || "").length,
      );
      yield put({
        type: types.GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_SUCCEEDED,
        exampleEmail: template,
      });
      console.log(
        "[DEBUG] dispatched GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_SUCCEEDED",
      );
    } else {
      yield put({ type: "GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_FAILED" });
    }
  } catch (err) {
    yield put({ type: "GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_FAILED", err });
  }
}

const rescheduleMessage =
  "Reschedule emails have been sent. The participant will have the option to choose another time and the assigned moderators have been be notified of the change.";
const cancelMessage =
  "Cancellation emails have been sent. The participant and moderators have been be notified of the change.";

const snackbarMessage = (
  <span>
    {
      "Moderator availability import is in-progress and will take up to two minutes. If no changes are made,"
    }
    <span
      className="copy-screeners-snackbar-link"
      onClick={() => window.location.reload()}
    >
      {"try refreshing your web page"}
    </span>
    <span>{". You cannot make any changes while the import is ongoing."}</span>
  </span>
);

function* sendMultiSessionRescheduleMessage({ payload }) {
  yield* authenticatedCall(
    "SEND_MULTI_SESSION_RESCHEDULE_MESSAGE",
    function* () {
      const timeSlots = yield call(API.sendMultiMessage, payload);
      yield put({
        type: "SEND_MULTI_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED",
        payload: timeSlots,
      });
      yield put({
        type: "FETCH_ALL_NECESSARY_PROJECT_INFO_REQUESTED",
        payload: payload.projectId,
      });
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message: `${
            payload.action === "cancel" ? "Cancellation" : "Reschedule"
          } messages sent`,
        },
      });
    },
  );
}

function* sendSingleSessionRescheduleMessage({ payload }) {
  try {
    if (
      payload.action === "reschedule" &&
      payload.invalidateReschedule === true &&
      !payload.hideBackButton
    ) {
      const selectedFromPayload = payload.invalidateSelected;
      const selectedFromState = yield select(
        (state) => state.scheduler.invalidateSelectedFromCompleted,
      );
      const selected = selectedFromPayload || selectedFromState || {};
      const reasonMap = {
        participant_no_show: "PARTICIPANT_NO_SHOW",
        moderator_no_show: "MODERATOR_NO_SHOW",
        other: "OTHER",
      };
      const userId = yield select((state) => state.user.userId);
      const selectedReasonKey =
        selected &&
        (selected.reason || (typeof selected === "string" && selected));
      const code =
        (selectedReasonKey && reasonMap[selectedReasonKey]) ||
        (selectedReasonKey || "").toUpperCase();
      const body = {
        timeSlotId: payload.timeSlotId,
        invalidationReasonCode: code,
        invalidatedByUserId: userId,
        isInvalidateEmailSent: payload.isInvalidateEmailSent,
      };
      if (
        code === "OTHER" &&
        selected &&
        selected.otherReason &&
        String(selected.otherReason).trim().length > 0
      ) {
        body.invalidationReasonText = String(selected.otherReason).trim();
      }
      const invalidateResponse = yield call(
        InterviewsAPI.invalidateInterview,
        body,
      );
      if (invalidateResponse.status === 200) {
        yield put({
          type: "SHOW_MESSAGE",
          payload: {
            message: !payload.isInvalidateEmailSent ? (
              <span>
                <strong>
                  {payload.projectName} {payload.participantId}
                </strong>{" "}
                has been invalidated.
              </span>
            ) : (
              <span>
                <strong>Reschedule emails have been sent.</strong> The
                participant will have the option to choose another time.
                Previous interview has been invalidated.
              </span>
            ),
            className: "copy-screeners-snackbar",
          },
        });
        if (payload.isModeratorManagement) {
          yield put({
            type: "FETCH_MODERATOR_AVAILABILITY_REQUESTED",
            payload: {
              moderatorId: payload.moderatorId,
              clientId: payload.clientId,
              isModeratorManagement: true,
            },
          });
          yield put({
            type: "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED",
            payload: invalidateResponse,
          });
          yield put({ type: "CLOSE_TIMESLOT_POPOVER" });
        } else {
          yield put({
            type: interviewTypes.MARK_INTERVIEW_RESCHEDULED,
            payload: { timeSlotId: payload.timeSlotId },
          });
          yield put({
            type: "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED",
            payload: invalidateResponse,
          });
          yield put({ type: "CLOSE_TIMESLOT_POPOVER" });
          // Switch Interviews view to Invalidated tab and refresh list
          try {
            const tabs = yield select((state) => state.interviewsList.tabs);
            if (tabs && Array.isArray(tabs)) {
              const activeTab = tabs.find((t) => t.active);
              const shouldKeepUpcomingActive =
                activeTab && activeTab.value === "upcoming";
              const updatedTabs = shouldKeepUpcomingActive
                ? tabs
                : tabs.map((t) => ({
                  ...t,
                  active: t.value === "invalidate",
                }));
              yield put({ type: "SET_TABS", payload: updatedTabs });
              yield put({ type: "FETCH_INTERVIEWS_LIST_REQUESTED" });
            }
          } catch (e) {
            // Non-blocking: if interviewsList not present, continue
          }
        }
        yield put({ type: "HIDE_MESSAGE" });
      } else {
        yield put({
          type: "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_FAILED",
        });
        yield put({
          type: "SHOW_MESSAGE",
          payload: {
            message: "Failed to invalidate interview",
            className: "copy-screeners-snackbar",
          },
        });
        yield put({ type: "HIDE_MESSAGE" });
      }
      return;
    } else if (
      payload.action === "reschedule" &&
      payload.invalidateReschedule === true &&
      payload.isInvalidateEmailSent === false
    ) {
      const resp = yield call(API.sendInvalidateRescheduleMail, {
        timeSlotId: payload.timeSlotId,
      });
      if (resp && resp.status === 200) {
        if (payload.isModeratorManagement) {
          yield put({
            type: "FETCH_MODERATOR_AVAILABILITY_REQUESTED",
            payload: {
              moderatorId: payload.moderatorId,
              clientId: payload.clientId,
              isModeratorManagement: true,
            },
          });
        }
        yield put({
          type: "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED",
          payload: resp,
        });
        yield put({ type: "CLOSE_TIMESLOT_POPOVER" });
        yield put({
          type: interviewTypes.MARK_INTERVIEW_RESCHEDULED,
          payload: { timeSlotId: payload.timeSlotId },
        });
        yield put({
          type: "SHOW_MESSAGE",
          payload: {
            message: (
              <span>
                <strong>Reschedule emails have been sent.</strong> The
                participant will have the option to choose another time.
                Previous interview has been invalidated.
              </span>
            ),
            className: "copy-screeners-snackbar",
          },
        });
        yield put({ type: "HIDE_MESSAGE" });
      } else {
        yield put({
          type: "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_FAILED",
        });
        yield put({
          type: "SHOW_MESSAGE",
          payload: {
            message: "Failed to send reschedule email",
            className: "copy-screeners-snackbar",
          },
        });
        yield put({ type: "HIDE_MESSAGE" });
      }
      return;
    } else {
      let timeSlots = yield call(API.sendSingleMessage, payload);
      if (timeSlots.status === 200) {
        yield put({
          type: "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED",
          payload: timeSlots,
        });
        yield put({ type: "CLOSE_TIMESLOT_POPOVER" });
        yield put({
          type: interviewTypes.MARK_INTERVIEW_RESCHEDULED,
          payload: { timeSlotId: payload.timeSlotId },
        });
        payload.singleModerator && isPMOrAdmin()
          ? yield put({
              type: "FETCH_MODERATOR_AVAILABILITY_REQUESTED",
              payload: {
                moderatorId: payload.singleModerator.id,
                clientId: payload.singleModerator.clientId,
                isModeratorManagement: payload.isModeratorManagement,
              },
            })
          : yield put({ type: "FETCH_MODERATOR_AVAILABILITY_REQUESTED" });
        if (payload.onSave) yield payload.onSave();
        yield put({
          type: "SHOW_MESSAGE",
          payload: {
            message:
              payload.action === "cancel" ? cancelMessage : rescheduleMessage,
            className: "copy-screeners-snackbar",
          },
        });
        yield put({ type: "HIDE_MESSAGE" });
      } else {
        yield put({ type: "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_FAILED" });
        yield put({
          type: "SHOW_MESSAGE",
          payload: {
            message:
              "There was an error processing your request, please try again",
            className: "copy-screeners-snackbar",
          },
        });
        yield put({ type: "HIDE_MESSAGE" });
      }
      return;
    }
  } catch (err) {
    yield put({ type: "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_FAILED", err });
    if (err && err.response && err.response.status === 405) {
      yield put({
        type: "SHOW_MESSAGE",
        payload: {
          message: snackbarMessage,
          title: "Update In-Progress",
          className: "error-snackbar copy-screeners-snackbar-link",
        },
      });
      yield put({ type: "HIDE_MESSAGE" });
    } else {
      // Only show global snackbar if this was a user-initiated action (reschedule/cancel)
      const shouldShowErrorSnackbar = Boolean(payload && payload.action);
      if (shouldShowErrorSnackbar) {
        yield put({
          type: "SHOW_MESSAGE",
          payload: {
            message:
              "There was an error processing your request, please try again",
            className: "copy-screeners-snackbar",
          },
        });
        yield put({ type: "HIDE_MESSAGE" });
      } else {
        console.log(
          "[EditSession] Suppressed global error snackbar for non-user-initiated failure",
        );
      }
    }
  }
}

function* getEmailTemplateRequested(payload) {
  try {
    const response = yield call(API.getEmailTemplate, payload.payload);
    if (response.status === 200) {
      const htmlDoc = new DOMParser().parseFromString(
        response.data.body_content,
        "text/html",
      );
      const ionqyElem = htmlDoc.getElementById("ionqy");
      if (!ionqyElem) {
        console.log(
          "[EditSession] GET_EMAIL_TEMPLATE_SUCCEEDED but missing #ionqy element",
        );
        // Let UI show inline preview error without global snackbar
        yield put({ type: "GET_EMAIL_TEMPLATE_FAILED" });
        return;
      }
      const template = { __html: ionqyElem.innerHTML };
      console.log(
        "[EditSession] GET_EMAIL_TEMPLATE_SUCCEEDED, template length:",
        (template.__html || "").length,
      );
      yield put({
        type: "GET_EMAIL_TEMPLATE_SUCCEEDED",
        exampleEmail: template,
      });
      yield put({
        type: "OPEN_PREVIEW_CONFERENCE_LINK_MODAL",
        payload: payload.payload,
      });
    } else {
      yield put({ type: "GET_EMAIL_TEMPLATE_FAILED" });
      console.log(
        "[EditSession] GET_EMAIL_TEMPLATE_FAILED status:",
        response.status,
      );
      console.log(
        "[EditSession] GET_EMAIL_TEMPLATE_REQUESTED payload:",
        payload.payload,
      );
      // Suppress global snackbar on preview failure; UI will show inline error
    }
  } catch (err) {
    console.log("get email tempalte request failed: ", err);
    yield put({ type: "GET_EMAIL_TEMPLATE_FAILED", err });
    // Suppress global snackbar on preview failure; UI will show inline error
  }
}

export default function* watchSessionEdit() {
  yield takeLatest(
    types.SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE,
    sendSingleSessionRescheduleMessage,
  );
  yield takeLatest(
    types.SEND_MULTI_SESSION_RESCHEDULE_MESSAGE,
    sendMultiSessionRescheduleMessage,
  );
  yield takeLatest(
    types.GET_EMAIL_TEMPLATE_REQUESTED,
    getEmailTemplateRequested,
  );
  yield takeLatest(
    types.GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_REQUESTED,
    getInvalidateInterviewEmailTemplateRequested,
  );
}
